<template>
  <div>
    <el-form class="search-form" ref="form" :model="form">
      <el-row>
        <!--<el-col :span="8">
       <el-form-item prop="status">
        <el-select
          class="search-select1"
          v-model="form.status"
          placeholder="请选择状态"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item"
            :value="index"
          ></el-option>
        </el-select>
      </el-form-item> 
      </el-col>-->
        <el-col :span="8">
          <el-form-item prop="status">
            <el-form-item
              label="邀请人"
              :label-width="formLabelWidth"
              prop="userId"
            >
              <el-select
                class="select"
                v-model="form.userId"
                filterable
                remote
                placeholder="请输入邀请人"
                :remote-method="searchUser"
                @change="checkItem"
                clearable
                :loading="loading"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="经纪人名称"
            :label-width="formLabelWidth"
            prop="salerName"
          >
            <el-input
              class="search-input"
              v-model="form.salerName"
              placeholder="请输入经纪人名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="经纪人电话"
            :label-width="formLabelWidth"
            prop="mobile"
          >
            <el-input
              class="search-input"
              v-model="form.mobile"
              placeholder="请输入经纪人电话"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="注册时间"
            prop="registrationTime"
          >
            <el-date-picker
              popper-class="search-date-input"
              v-model="registrationTime"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- <el-form-item prop="userName">
        <el-select
          class="select"
          v-model="userName"
          filterable
          remote
          placeholder="请输入推荐人名字"
          :remote-method="searchUser"
          @change="checkItem"
          clearable
          :loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="handleUserDecrypt(item.label)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="dateTime">
        <el-date-picker
          v-model="dateTime"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          prop="dateTime"
        >
        </el-date-picker>
      </el-form-item> -->
        <el-col :span="8">
          <el-form-item class="btn">
            <!-- <el-button
          @click="onExport"
          v-if="roleList[path].includes('_Export')"
          icon="el-icon-download"
          size="small"
          >导出</el-button
        > -->

            <el-button @click="onSearch" icon="el-icon-search" size="small"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-plus"
              @click="resetForm('form')"
              >清空</el-button
            >
            <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
              >刷新</el-button
            >
            <!-- 导出 -->
            <PermissionsBtn
              :icon="'el-icon-download'"
              :btnType="'primary'"
              :permissionName="'_Export'"
              :downloadUrl="'/userAdmin/Agent/downLoad'"
              :form="exportForm"
              :checkList="checkList"
            ></PermissionsBtn>
            <!-- <el-button size="small" icon="el-icon-plus" @click="onAdd" type="success" >新增</el-button> -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user';
import { download } from '@/utils/download';
import { encrypt, decrypt } from '@/utils/encryp';
import { getLastMonthTimeRange } from '@/utils';
export default {
  name: 'UserSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formLabelWidth: '100px', // 对话框中 文本的尺寸
      // 表单内容
      form: {
        userId: '',
        salerName: '',
        mobile: '',
        creationStartTime: '',
        creationEndTime: '',
      },
      exportForm: {},
      registrationTime: [],
      userName: '',
      dateTime: [],
      options: [],
      loading: false,
      path: '',
    };
  },

  computed: {
    ...mapGetters(['statusList', 'pickerOptions', 'roleList']),
  },
  watch: {
    // 将标准时间转换成 yyyy-mm-dd
    // dateTime: function (val) {
    //   let timeList = val.map((item) => {
    //     return this.$moment(item).format('YYYY-MM-DD HH:mm:ss');
    //   });
    //   this.form.startTime = timeList[0];
    //   this.form.endTime = timeList[1];
    //   return;
    // },
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    let { houseId } = JSON.parse(localStorage.getItem('userInfo'));
    // console.log('houseId', houseId);
    this.form['houseId'] = houseId;

    // 获取最近一个月的时间
    this.registrationTime = getLastMonthTimeRange();
  },
  methods: {
    // 搜索用户
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择下拉选项
    checkItem(val) {
      // console.log('选中的值：', val);
      this.form.userId = val;
    },

    // 导出
    async onExport() {
      // console.log('导出数量', this.checkList);
      try {
        await this.$axios({
          url: window.RequestUrl + '/userAdmin/Agent/downLoad',
          method: 'GET', //get
          responseType: 'arraybuffer',
          params: {
            idList: String(this.checkList),
            salerName: '',
            // pageIndex: '1',
            // pageSize: '20',
            isExport: this.checkList.length == 0,
            userId: '',
          },
          headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
        }).then((res) => {
          // 调用封装好的下载函数
          download(
            res.data,
            'application/excel;charset=UTF-8',
            this.$moment().format('YYYY-MM-DD-HH-mm') + '.xlsx'
          );
        });
      } catch (e) {
        console.log(e);
      }
    },
    // 搜索，触发父组件请求数据的方法
    onSearch() {
      // 0 = 全部， 没有0这个状态，重置为0
      if (this.form.status === 0) {
        this.form.status = '';
      }
      // console.log('时间：', this.registrationTime);
      this.form['creationStartTime'] = this.registrationTime
        ? this.registrationTime[0]
        : '';
      this.form['creationEndTime'] = this.registrationTime
        ? this.registrationTime[1]
        : '';
      this.form['inviteUserId'] = this.form.userId;

      // this.form['pageIndex'] = 1;
      // console.log('form', this.form);
      let { salerName, mobile } = this.form;
      this.exportForm = {
        ...this.form,
        ...{
          salerName: salerName ? encrypt(salerName) : '',
          mobile: mobile ? encrypt(mobile) : '',
        },
      };
      this.$emit('search', this.exportForm);
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm(formName) {
      this.dateTime = '';
      // 获取最近一个月的时间 - 默认
      this.registrationTime = getLastMonthTimeRange();
      this.userName = '';
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  // margin: 0 10px;
  width: 260px;
}

.search-select1 {
  // width: 120px;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
<style lang="less">
.search-date-input {
  .el-picker-panel__link-btn {
    &:nth-child(1) {
      display: none;
    }
  }
}
</style>
